import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanMatch, Route, Router, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { NotificationService } from '@core/services/notification.service';
import { UserService } from '@core/services/user.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class NodeGuard implements CanMatch {
  private router = inject(Router);
  private userService = inject(UserService);
  private notificationService = inject(NotificationService);

  token: string;
  appId: string;

  constructor() {
    this.appId = this.userService.getAppId();
  }

  canMatch(route: Route, segments: UrlSegment[]): boolean {
    let roles: Array<string> = route.data?.role || [];
    let strict: boolean = route.data?.strictRoles;
    let specificRole: string = route.data?.specificRole;
    let feature: string = route.data?.feature;

    if (this.toHaveAccess(roles, strict, specificRole, feature)) {
      return true;
    }

    this.getErrorAndRedirect(roles);
    return false;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let roles: Array<string> = route.data?.role || [];
    let strict: boolean = route.data?.strictRoles;
    let specificRole: string = route.data?.specificRole;
    let feature: string = route.data?.feature;

    if (this.toHaveAccess(roles, strict, specificRole, feature)) {
      return true;
    }

    this.getErrorAndRedirect(roles);
    return false;
  }

  private toHaveAccess(
    roles: string[],
    strict?: boolean,
    specificRole?: string,
    feature?: string
  ): boolean {
    let isLoggedIn;

    this.userService.isLoggedIn$.subscribe((res) => {
      isLoggedIn = res;
    });

    const hasRole = isLoggedIn && this.userService.checkRoles(roles, strict, specificRole);

    if (!hasRole) {
      return false;
    }

    if (feature) {
      return this.isFeatureEnabled(feature);
    }

    return true;
  }

    private isFeatureEnabled(feature: string): boolean {

    if (environment.hasOwnProperty(feature)) {
      return environment[feature] === true;
    }

    return true;
  }

  private getErrorAndRedirect(roles): void {
    this.router.navigate(['error', '401'], {
      queryParams: {
        returnUrl: window.location.pathname,
        returnSearch: window.location.search,
        canAccess: this.toHaveAccess(roles),
      },
    });
    this.notificationService.error('COMMONS.ERROR.ROUTING_ERROR', 'COMMONS.ERROR.TITLE');
  }
}
